import React, {Component} from 'react'
import './styles.css'
import imgLogoDarkFull from 'assets/images/logo-dark-full.png'

class Footer extends Component {
  render = () => (
    <footer className="row footer-3 bg--white text-center-xs">
      <div className="col-sm-4">
        <img alt="logo" className="logo" src={imgLogoDarkFull} style={{marginTop: '-1.25rem'}}/>
        <span>(02) 8913-1001</span><br/>
        <span>新北市新店區北新路3段207-2號8樓</span>
      </div>
      {/* <div className="col-sm-5">
        <ul className="footer__navigation">
          <li>
            <a role="button">About</a>
          </li>
          <li>
            <a role="button">Contact</a>
          </li>
        </ul>
      </div> */}
      <div className="col-sm-3 col-sm-offset-5 text-right text-center-xs">
        {/* <ul className="social-list">
          <li>
            <a role="button"><i className="socicon-twitter"></i></a>
          </li>
          <li>
            <a role="button"><i className="socicon-dribbble"></i></a>
          </li>
          <li>
            <a role="button"><i className="socicon-vimeo"></i></a>
          </li>
          <li>
            <a role="button"><i className="socicon-instagram"></i></a>
          </li>
        </ul> */}
        <span className="type--fine-print">
          &copy; Copyright <span className="update-year">2017</span><br/>
          慎康企業股份有限公司 - All Rights Reserved
        </span>
      </div>
    </footer>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/index.js